import { useEffect, useState } from "react";
import { useDeviceList } from "./provider/DeviceListProvider";
import { Link, useNavigate, useParams } from "react-router-dom";
import TopBar from "../components/TopBar/TopBar";
import ContextMenuTrigger from "../components/ContextMenu/ContextMenuTrigger";
import BorderlessButton from "../components/Button/BorderlessButton";
import ContextMenu from "../components/ContextMenu/ContextMenu";
import ContextMenuButton from "../components/ContextMenu/ContextMenuButton";
import UpDownIcon from "../components/Icons/UpDownIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faMobileScreen, faSignOut, faUserAlt } from "@fortawesome/free-solid-svg-icons";
import { useUser } from "./provider/UserAuthProvider";
import IconButton from "../components/Button/IconButton";
import InitialAvatarView from "../components/InitalAvatarView/InitialAvatarView";
import LangSettingButton from "./LangSettingButton";
import { useTranslation } from "react-i18next";

function FSendTopBar({ topBarShowBottomLine = false }) {
  const { deviceList } = useDeviceList();
  const { deviceId } = useParams();
  const [curDevice, setCurDevice] = useState(null);
  const user = useUser();
  const { t } = useTranslation();

  useEffect(() => {
    const newDevice = deviceList.find((device) => {
      return device.deviceId === deviceId;
    });
    console.log("newDevice:");
    console.log(newDevice);
    if (newDevice != null) {
      setCurDevice((prev) => {
        return newDevice;
      });
    } else {
      setCurDevice(null);
    }
  }, [deviceId, deviceList]);

  return (
    <TopBar
      showBottomLine={topBarShowBottomLine}
      title={
        <Link className="text-[16px]" to={"/"}>
          {t("appName")}
        </Link>
      }
      rightActions={
        <>
          {curDevice && <DeviceListSpinner curDevice={curDevice} deviceList={deviceList} />}
          {user.user && (
            <ContextMenuTrigger
              trigger={
                <div className="flex flex-row  items-center gap-2 cursor-pointer">
                  {user.user.avatarUrl && (
                    <img
                      src={user.user.avatarUrl}
                      alt={user.user.name}
                      className="w-8 h-8 rounded-full cursor-pointer"
                    />
                  )}
                  {!user.user.avatarUrl && (
                    <InitialAvatarView name={user.user.nickname || user.user.name || "用户"} diameter={32} />
                  )}
                  <span className="text-[14px]">{user.user.nickname}</span>
                </div>
              }
              contextMenu={
                <ContextMenu>
                  <ContextMenuButton
                    text={t("logout")}
                    leftIcon={<FontAwesomeIcon icon={faSignOut} />}
                    onClick={() => {
                      user.logout();
                    }}
                  />
                </ContextMenu>
              }
            ></ContextMenuTrigger>
          )}
          <LangSettingButton />
        </>
      }
    />
  );
}

function DeviceListSpinner({ curDevice, deviceList }) {
  const navigate = useNavigate();
  return (
    <ContextMenuTrigger
      trigger={
        <BorderlessButton
          text={curDevice.name}
          leftIcon={<FontAwesomeIcon icon={faMobileScreen} />}
          rightIcon={<UpDownIcon />}
        />
      }
      contextMenu={
        <ContextMenu width={250}>
          {deviceList.map((device) => {
            const isCur = device === curDevice;
            return (
              <ContextMenuButton
                key={device.deviceId}
                text={device.name}
                leftIcon={<FontAwesomeIcon icon={faMobileScreen} />}
                rightIcon={<>{isCur && <FontAwesomeIcon icon={faCheck} />}</>}
                onClick={() => {
                  navigate(`/device/${device.deviceId}`);
                }}
              />
            );
          })}
        </ContextMenu>
      }
    />
  );
}

export default FSendTopBar;
